var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"dropdown-item dots-options",attrs:{"title":'تعديل',"href":"javascript:void(0);","to":_vm.routing}},[_c('i',{staticClass:"flaticon-edit-7"}),_vm._v(" تعديل")])
}
var staticRenderFns = []

export { render, staticRenderFns }